import { render } from "./KurvaNormalPegawai.vue?vue&type=template&id=3cbb0552"
import script from "./KurvaNormalPegawai.vue?vue&type=script&lang=js"
export * from "./KurvaNormalPegawai.vue?vue&type=script&lang=js"

import "./KurvaNormalPegawai.vue?vue&type=style&index=0&id=3cbb0552&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__